var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"w-full lg:w-8/12 px-4"},[_c('CardSettings')],1),_c('div',{staticClass:"w-full lg:w-4/12 px-4"},[_c('CardProfile')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }